/*eslint-disable @typescript-eslint/no-explicit-any*/
import React, { useEffect } from "react";

import { useNavigate } from "react-router-dom";
import { getUserApi } from "../api/Api";
import axios from "axios";
import {useAuth} from "../providers/AuthProvider";

function Redirect() {
	const navigate = useNavigate();
	const {setNewToken} = useAuth();
	// 目前直接返回 token
	// const getToken = async (code: string) => {
	// 	try {
	// 		const res = (await GetTokenApi({ code: code })) as any;

	// 		if (res) {
	// 			setToken(res?.id_token);
	// 		}
	// 	} catch (e) {
	// 		console.log(e);
	// 	}
	// };

	useEffect(() => {
		const urlParams = new URLSearchParams(window.location.search);
		console.log(urlParams, "urlParams");

		const tokenParam = urlParams.get("token");
		setNewToken(tokenParam);
		console.log(tokenParam, "tokenParam");

		if (tokenParam) {
			localStorage.setItem("token", tokenParam);
			getUserData();
		}
	}, []);

	{
		/* 获取用户数据 */
	}
	// const getUserData = () => {
	// 	getUserApi().then((res: object) => {
	// 		localStorage.setItem("user", JSON.stringify(res));
	// 		navigate("/d5data");
	// 	});
	// };

	const getUserData = async () => {
		getUserApi()
			.then((res: object) => {
				localStorage.setItem("user", JSON.stringify(res));
				navigate("/d5data");
			})
			.catch((e: Error) => {
				// toast.error("Failed to get user info");
				console.log(e.message);
			});
		// try {
		// 	const res = await axios.get(
		// 		"https://staging.api.d5data.tech:18070/user/me",
		// 		{
		// 			headers: {
		// 				Authorization: `Bearer ${localStorage.getItem("token")}`, // 使用 Bearer 方案
		// 			},
		// 		}
		// 	);
		// 	if (res?.data) {
		// 		localStorage.setItem("user", JSON.stringify(res?.data));
		// 		navigate("/d5data");
		// 	}
		// } catch (e) {
		// 	console.log(e);
		// }
	};

	return <></>;
}

export default Redirect;
